/* eslint-disable react-hooks/exhaustive-deps, no-empty-function */
import { useEffect, useState } from 'react';
import fallbackIcon from './icons/placeholder.svg';

(window as any).IMAGES = {};
(window as any).ERROR_IMAGES = {};

const appImages = (window as any).IMAGES;
const appErrorImages = (window as any).ERROR_IMAGES;

const preloadFallbackIcon = (path: string) => {
  const image = new Image();
  appImages[path] = image;
  image.src = path;
};

preloadFallbackIcon(fallbackIcon);

const useIcon = (initPath: string, error: boolean, condition: boolean) => {
  const [path, setPath] = useState('');

  useEffect(() => {
    let flag = true;

    const loadImage = () => {
      if (flag) {
        setPath(initPath);
      }
    };

    if (error) {
      appErrorImages[initPath] = fallbackIcon;
      if (flag) {
        setPath(appErrorImages[initPath]);
      }
    } else {
      if (condition) {
        if (flag) {
          setPath('');
        }
        if (appErrorImages[initPath]) {
          if (flag) {
            setPath(appErrorImages[initPath]);
          }
        } else if (appImages[initPath]) {
          loadImage();
        } else {
          const image = new Image();
          appImages[initPath] = image;
          image.onerror = loadImage;
          image.onload = loadImage;
          image.src = initPath;
        }
      }
    }

    return () => {
      flag = false;
    };
  }, [initPath, error]);

  return path;
};

export default useIcon;
